import AWS from 'aws-sdk';
import axios from 'axios';
import useRefreshTokenInterval from 'contexts/token';
import jwt from 'jsonwebtoken';
import queryString from 'query-string';
import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import accountService from 'services/account';
import courseService from 'services/course';
import userService from 'services/user';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    ResponsiveDialog,
    Stack,
    styled,
    Text,
} from 'shell/components';
const AuthContext = createContext();
const useAuth = () => useContext(AuthContext);

const ExpiredTokenDialog = ({ open, handleRedirect, handleClose, t }) => (
    <CustomResponsiveDialog open={open} scroll={'paper'} onClose={handleClose}>
        <DialogTitle sx={{ padding: 0 }}>
            <Stack direction={'row'} justifyContent={'flex-end'}>
                <IconButton
                    aria-label={'close'}
                    kind={'exit'}
                    size={'small'}
                    variant={'square'}
                    onClick={handleClose}
                />
            </Stack>
        </DialogTitle>
        <DialogContent>
            <Stack spacing={2} alignItems={'center'}>
                <svg width={150} height={79} viewBox='0 0 150 79' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_11129_147024)'>
                        <path
                            d='M82.2363 16.4473C84.7797 16.4473 86.8418 18.5093 86.8418 21.0527C86.8417 23.5961 84.7797 25.6582 82.2363 25.6582H124.342C126.885 25.6582 128.947 27.7194 128.947 30.2627C128.947 32.8061 126.885 34.8682 124.342 34.8682H138.815C141.359 34.8682 143.421 36.9302 143.421 39.4736C143.421 42.017 141.359 44.0791 138.815 44.0791H126.315C123.772 44.0792 121.71 46.1412 121.71 48.6846C121.71 51.2277 123.772 53.2889 126.315 53.2891H130.263C132.806 53.2891 134.868 55.3512 134.868 57.8945C134.868 60.4379 132.806 62.5 130.263 62.5H96.0527C95.714 62.5 95.3833 62.463 95.0654 62.3936C94.7476 62.4629 94.4177 62.5 94.0791 62.5H34.21C31.6668 62.4998 29.6055 60.4378 29.6055 57.8945C29.6055 55.3513 31.6668 53.2893 34.21 53.2891H8.55273C6.00947 53.2891 3.94752 51.2278 3.94727 48.6846C3.94727 46.1412 6.00932 44.0791 8.55273 44.0791H34.8682C37.4116 44.0791 39.4736 42.017 39.4736 39.4736C39.4736 36.9302 37.4116 34.8682 34.8682 34.8682H18.4209C15.8775 34.8681 13.8154 32.8061 13.8154 30.2627C13.8156 27.7195 15.8776 25.6582 18.4209 25.6582H44.7363C42.1932 25.658 40.1319 23.5959 40.1318 21.0527C40.1318 18.5095 42.1931 16.4475 44.7363 16.4473H82.2363ZM141.447 53.2891C143.991 53.2891 146.053 55.3512 146.053 57.8945C146.053 60.4379 143.991 62.5 141.447 62.5C138.904 62.4999 136.842 60.4379 136.842 57.8945C136.842 55.3512 138.904 53.2891 141.447 53.2891Z'
                            fill='#F0F0F2'
                        />
                        <path
                            d='M53.2901 67.2704C53.7443 67.2704 54.1125 66.9022 54.1125 66.448C54.1125 65.9939 53.7443 65.6257 53.2901 65.6257V67.2704ZM54.3013 38.1925L54.2459 39.013L55.2969 39.0839L55.1107 38.0471L54.3013 38.1925ZM97.526 27.0859L96.7464 27.3477L96.9562 27.9723L97.6115 27.9038L97.526 27.0859ZM101.316 66.4337L101.251 65.6139L100.494 65.6743V66.4337H101.316ZM101.316 66.448V67.2704H102.139V66.448H101.316ZM64.1505 65.6257C63.6963 65.6257 63.3281 65.9939 63.3281 66.448C63.3281 66.9022 63.6963 67.2704 64.1505 67.2704V65.6257ZM61.1821 67.2704C61.6363 67.2704 62.0045 66.9022 62.0045 66.448C62.0045 65.9939 61.6363 65.6257 61.1821 65.6257V67.2704ZM56.6001 65.6257C56.1459 65.6257 55.7778 65.9939 55.7778 66.448C55.7778 66.9022 56.1459 67.2704 56.6001 67.2704V65.6257ZM53.2901 66.448V65.6257C45.7328 65.6257 39.6388 59.6433 39.6388 52.3033H38.8164H37.994C37.994 60.5871 44.8602 67.2704 53.2901 67.2704V66.448ZM38.8164 52.3033H39.6388C39.6388 44.9633 45.7328 38.9809 53.2901 38.9809V38.1586V37.3362C44.8602 37.3362 37.994 44.0195 37.994 52.3033H38.8164ZM53.2901 38.1586V38.9809C53.6115 38.9809 53.9303 38.9918 54.2459 39.013L54.3013 38.1925L54.3566 37.372C54.0041 37.3483 53.6485 37.3362 53.2901 37.3362V38.1586ZM54.3013 38.1925L55.1107 38.0471C54.8871 36.8029 54.7704 35.521 54.7704 34.2112H53.948H53.1256C53.1256 35.619 53.2512 36.9982 53.4918 38.338L54.3013 38.1925ZM53.948 34.2112H54.7704C54.7704 22.3116 64.4168 12.6651 76.3164 12.6651V11.8428V11.0204C63.5085 11.0204 53.1256 21.4033 53.1256 34.2112H53.948ZM76.3164 11.8428V12.6651C85.8151 12.6651 93.8801 18.8122 96.7464 27.3477L97.526 27.0859L98.3056 26.8241C95.2212 17.6391 86.5428 11.0204 76.3164 11.0204V11.8428ZM97.526 27.0859L97.6115 27.9038C98.2881 27.833 98.9754 27.7967 99.6717 27.7967V26.9744V26.152C98.9182 26.152 98.1738 26.1913 97.4405 26.268L97.526 27.0859ZM99.6717 26.9744V27.7967C110.312 27.7967 118.915 36.2778 118.915 46.7112H119.737H120.56C120.56 35.3439 111.195 26.152 99.6717 26.152V26.9744ZM119.737 46.7112H118.915C118.915 56.626 111.148 64.8241 101.251 65.6139L101.316 66.4337L101.382 67.2534C112.11 66.3974 120.56 57.5077 120.56 46.7112H119.737ZM101.316 66.4337H100.494V66.448H101.316H102.139V66.4337H101.316ZM101.316 66.448V65.6257H64.1505V66.448V67.2704H101.316V66.448ZM61.1821 66.448V65.6257H56.6001V66.448V67.2704H61.1821V66.448Z'
                            fill='#9D9BA7'
                        />
                        <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M69.4817 16.6724C69.4817 37.8718 88.5741 55.3404 113.158 57.6988C110.077 61.4872 105.319 64.0572 99.8992 64.461V64.4733H55.7519C50.3955 64.4733 41.4473 62.2165 41.4473 52.334C41.4473 42.4516 48.4039 40.1948 55.7519 40.1948C56.0644 40.1948 56.3743 40.2046 56.6814 40.2239C56.468 39.1151 56.4305 37.9722 56.3567 36.8071C55.8577 28.9365 59.2913 19.0173 69.4936 15.7891C69.4854 16.0834 69.4817 16.3775 69.4817 16.6724Z'
                            fill='#E2E1E5'
                        />
                        <path
                            d='M82.895 19.7363C87.1772 20.8696 90.5583 24.2185 91.7373 28.4818'
                            stroke='#BFBEC6'
                            strokeWidth={1.64474}
                            strokeLinecap='round'
                        />
                        <path
                            d='M63.8158 41.1182C63.8158 43.48 65.8777 45.3945 68.4211 45.3945C70.9645 45.3945 73.0264 43.48 73.0264 41.1182'
                            stroke='#9D9BA7'
                            strokeWidth={1.64474}
                            strokeLinecap='round'
                        />
                        <path
                            d='M82.8949 41.1182C82.8949 43.48 84.9568 45.3945 87.5002 45.3945C90.0436 45.3945 92.1055 43.48 92.1055 41.1182'
                            stroke='#9D9BA7'
                            strokeWidth={1.64474}
                            strokeLinecap='round'
                        />
                        <path
                            d='M73.0264 53.2897H82.5658'
                            stroke='#9D9BA7'
                            strokeWidth={1.64474}
                            strokeLinecap='round'
                        />
                        <path
                            d='M47.084 25.0635L42.7051 30.4424H47.1895V31.5791H41.0312V30.5049L45.4102 25.2002H41.3682V24.0635H47.084V25.0635ZM38.2607 15.3828L32.2393 22.7793H38.4053V24.3418H29.9385V22.8662L35.959 15.5713H30.4014V14.0078H38.2607V15.3828Z'
                            fill='#BFBEC6'
                        />
                    </g>
                    <defs>
                        <clipPath id='clip0_11129_147024'>
                            <rect width={150} height={78.9474} fill='white' />
                        </clipPath>
                    </defs>
                </svg>
                <Text variant={'h6'}>{t('lms.expired-title', 'Your LMS Authorization Has Expired')}</Text>
                <Text sx={{ maxWidth: '412px', textAlign: 'center' }}>
                    {t(
                        'lms.expired-description',
                        'Your connection has expired, which may prevent some features from working properly. Click the button below to go to the reauthorization page and reconnect your account.'
                    )}
                </Text>
            </Stack>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'space-between', padding: 0 }}>
            <Button color={'neutral'} variant={'tertiary'} onClick={handleClose}>
                {t('common:controls.cancel', 'Cancel')}
            </Button>
            <Button onClick={handleRedirect}>{t('lms.reauthorize-now', 'Reauthorize Now')}</Button>
        </DialogActions>
    </CustomResponsiveDialog>
);

const AuthProvider = (props) => {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation('auth');

    const [auth, setAuth] = useState();
    const [currentUser, setCurrentUser] = useState();
    const [loading, setLoading] = useState(false);
    const [openTokenDialog, setOpenTokenDialog] = useState(false);

    const cachedCredentials = useRef(null);
    const tokenCache = useRef(new Map());

    const updateCurrentUser = async (data) => {
        const updateUser = await userService.updateUser(auth.user_id, data);
        setCurrentUser(updateUser);
        return updateUser;
    };

    const sessionExpired = () => {
        return logout({ isExpired: true });
    };

    const logout = useCallback(
        async ({ isExpired = false }) => {
            localStorage.removeItem('auth_token');
            axios.defaults.headers.common.Authorization = undefined;
            setAuth(undefined);
            if (isExpired) {
                setLoading(false);
                return history.push('/', { isExpired });
            }
            return history.push('/');
        },
        [history]
    );

    const getCurrentUser = () => currentUser || null;

    const updateNotificationPreferences = async (newNotification) => {
        try {
            setAuth((auth) => ({
                ...auth,
                notification: newNotification,
            }));
            await accountService.updateAccount(auth.owner_account_id, { notification: newNotification });
        } catch (e) {
            console.error(e);
        }
    };

    const updateProfile = async (data) => {
        const prevUser = { ...currentUser };
        const updatedUser = {
            ...currentUser,
            ...data,
        };
        setCurrentUser(updatedUser);

        try {
            await userService.updateUser(currentUser.id, data);
        } catch (e) {
            setCurrentUser(prevUser);
        }
    };

    const changeAccount = () => {
        setAuth((current) => ({ iat: current.iat, user_id: current.user_id, username: current.username }));
        return history.push('/');
    };

    const getAccount = async () => {
        if (!auth) return;
        return await accountService.findAccount(auth.owner_account_id);
    };

    const selectAccount = async (accountId, course) => {
        try {
            setLoading(true);
            const res = await accountService.selectAccount(accountId, {
                owner_account_id: accountId,
                accessToken: localStorage.getItem('access_token'),
                course_data: course,
            });
            const { auth_token: token } = res;
            if (!res.has_access) {
                setLoading(false);
                throw new Error('No access to department');
            }
            localStorage.setItem('auth_token', token);
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            const cachedUser = jwt.decode(token);
            const accountData = await accountService.findAccount(cachedUser.owner_account_id);
            const courseData = await courseService.findCourse(accountData.course_id);
            setAuth({ ...cachedUser, ...accountData });

            if (
                !courseData?.finished_course_set_up &&
                accountData?.role !== 'student' &&
                courseData?.created_on > new Date('2021-12-01').getTime()
            ) {
                history.push('/course-set-up');
            } else if (
                accountData?.role === 'instructor' ||
                accountData?.role === 'ta' ||
                accountData?.role === 'student'
            ) {
                history.push('/assignments');
            } else {
                history.push('/dashboard');
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;

    // Fetch or return cached account token
    const getCachedAccountToken = useCallback(async (ownerAccountId) => {
        const cachedToken = tokenCache.current.get(ownerAccountId);

        if (cachedToken && cachedToken.expiresAt > Date.now()) {
            return cachedToken;
        }

        const accountTokens = await accountService.getAccountTokens(ownerAccountId);
        const tokenExpiryTime = Date.now() + 55 * 60 * 1000; // 55 minutes

        tokenCache.current.set(ownerAccountId, {
            IdentityId: accountTokens.IdentityId,
            Token: accountTokens.Token,
            expiresAt: tokenExpiryTime,
        });

        return accountTokens;
    }, []);

    // Fetch or return cached AWS credentials
    const getAwsCredentials = useCallback(
        async (accountId) => {
            if (cachedCredentials.current && !cachedCredentials.current.needsRefresh()) {
                return cachedCredentials.current;
            }

            const accountTokens = await getCachedAccountToken(accountId);
            cachedCredentials.current = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: AWS_IDENTITY_POOL_ID,
                IdentityId: accountTokens.IdentityId,
                Logins: { 'cognito-identity.amazonaws.com': accountTokens.Token },
            });

            await cachedCredentials.current.getPromise(); // Ensure credentials are ready
            return cachedCredentials.current;
        },
        [AWS_IDENTITY_POOL_ID, getCachedAccountToken]
    );

    useEffect(() => {
        if (!auth?.owner_account_id) return;

        let intervalId;
        let running = false; // prevent overlap
        const REFRESH_MS = 30 * 60 * 1000;

        const updateAWSConfig = async () => {
            if (running) return;
            running = true;
            try {
                AWS.config.update({ region: process.env.REACT_APP_AWS_REGION });

                const c = await getAwsCredentials(auth.owner_account_id);
                AWS.config.update({
                    credentials: new AWS.Credentials(c.accessKeyId, c.secretAccessKey, c.sessionToken),
                });
            } catch (e) {
                console.error('Failed to refresh AWS creds:', e);
            } finally {
                running = false;
            }
        };

        // initial fetch
        updateAWSConfig();

        // every 1 minute
        intervalId = setInterval(() => {
            updateAWSConfig().catch(console.error);
        }, REFRESH_MS);

        return () => clearInterval(intervalId);
    }, [auth?.owner_account_id, getAwsCredentials]);

    useEffect(() => {
        const getCurrentSession = async () => {
            let cachedUser = null;

            let token = localStorage.getItem('auth_token');
            const access_token = localStorage.getItem('access_token');
            if (auth && location.pathname === '/lti-launch') {
                const { token: ltiLaunchToken } = queryString.parse(location.search);
                localStorage.removeItem('auth_token');
                if (ltiLaunchToken) {
                    localStorage.setItem('auth_token', ltiLaunchToken);
                    token = ltiLaunchToken;
                }
            }
            if (token) {
                setLoading(true);
                cachedUser = jwt.decode(token);
                axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                if (cachedUser?.owner_account_id) {
                    const accountData = await accountService.findAccount(cachedUser.owner_account_id);
                    if (accountData?.active === false) return await logout({ isExpired: true });
                    setAuth({ ...cachedUser, ...accountData });
                    const userData = await userService.getUser(cachedUser.user_id);
                    setCurrentUser(userData);
                    if (accountData?.course_id) {
                        const existingCourseData = await courseService.findCourse(accountData?.course_id);

                        if (cachedUser.role === 'instructor' && !existingCourseData?.finished_course_set_up) {
                            history.push('/course-set-up');
                        }

                        if (userData && cachedUser?.role && cachedUser.role !== 'admin' && !userData.profile_set_up) {
                            history.push('/profile-setup');
                        }
                    }
                } else {
                    if (cachedUser?.user_id) {
                        const userData = await userService.getUser(cachedUser.user_id);
                        setCurrentUser(userData);
                        setAuth({ ...cachedUser, ...userData });
                        if (userData && !userData.profile_set_up) {
                            history.push('/profile-setup');
                        }
                    } else {
                        if (!token || !access_token) {
                            setLoading(false);
                            return history.push('/lti-incomplete');
                        }
                    }
                }
                setLoading(false);
            }
        };

        if (!auth) {
            getCurrentSession();
        }
    }, [auth, history, location.pathname, location.search, logout]);

    const handleRefreshFailed = useCallback((err) => {
        console.error('Token refresh failed:', err);
        setOpenTokenDialog(true);
    }, []);

    useRefreshTokenInterval({
        auth,
        onRefreshFailed: handleRefreshFailed,
    });

    return (
        <AuthContext.Provider
            value={{
                loading,
                auth,
                currentUser,
                setAuth,
                getCurrentUser,
                setCurrentUser,
                updateCurrentUser,
                updateNotificationPreferences,
                updateProfile,
                logout,
                changeAccount,
                sessionExpired,
                getAccount,
                selectAccount,
            }}
            {...props}
        >
            {props.children}
            {ExpiredTokenDialog({
                open: openTokenDialog,
                handleRedirect: () => {
                    window.location.href = `${window.location.origin}/api-launch`;
                    setOpenTokenDialog(false);
                },
                handleClose: () => {
                    setOpenTokenDialog(false);
                },
                t,
            })}
        </AuthContext.Provider>
    );
};

const CustomResponsiveDialog = styled(ResponsiveDialog)(() => {
    return {
        '& .MuiPaper-root > .MuiBox-root': {
            padding: 0,
        },
        '& .MuiDialog-paper': {
            width: '632px',
            height: '330px',
            padding: 24,
        },
    };
});

export { useAuth };
export default AuthProvider;
